/* eslint-disable local-rules/scoped-modules */
require('./publicPath');
performance.mark('MK_INIT');
require('./polyfill');
import { getSingleton } from '@meego/remote-loader/src/loader/RemoteModuleManager';
import { init } from './remote/init';
import { IS_SIMPLE_PAGE } from '@meego/biz-utils/src/const';
import { recordLaunchMetrics, LaunchMetricsKey } from '../../biz-utils/src/monitors/launchMetrics';
import {
  metricsSceneEventListener,
  prefetchMiniWorkItem,
} from './utils/metricsLifecyclePrefetch/metricsSceneEventListener';

recordLaunchMetrics(LaunchMetricsKey.START_TIMESTAMP, performance.now());

// mf 机制需提前加载
init();
require('./remote/external-config/coreExternal').init();

// @meego-remote/core 包资源使用同步加载（async = false）优先执行
getSingleton().getHandler('@meego-remote/core').setSyncLoad();
import(
  /* webpackChunkName: "fw-core" */
  './mfw'
)
  .then(async ({ ServiceContextProvider, bootstrap, IIframeLoginCheckService }) => {
    const st = performance.now();
    recordLaunchMetrics(LaunchMetricsKey.BOOTSTRAP_START, st);
    const { ioc } = bootstrap();
    recordLaunchMetrics(LaunchMetricsKey.BOOTSTRAP_COST, performance.now() - st);
    if (process.env.isKA) {
      const loginCheckStartTime = performance.now();
      await ioc.get(IIframeLoginCheckService).checkLogin();
      recordLaunchMetrics(
        LaunchMetricsKey.WAIT_LOGIN_CHECK,
        performance.now() - loginCheckStartTime,
      );
    }
    if (IS_SIMPLE_PAGE) {
      import('../../light_base/src/bootstrap')
        .then(s => {
          s.setOpts({
            CompWrapper: {
              Comp: ServiceContextProvider,
              props: { name: 'ApplictionRoot', value: { ioc } },
            },
            ioc,
          });
        })
        .catch(err => {
          console.error('bootstrap fail!', err);
          throw err;
        });
    } else {
      prefetchMiniWorkItem();
      // 执行时机太靠前，不引入其他依赖，临时这样判断
      metricsSceneEventListener();

      // 逻辑
      import(
        /* webpackChunkName: "lifecycle" */
        './lifecycle'
      );
      // 路由
      import(
        /* webpackChunkName: "bootstrap" */
        './bootstrap'
      )
        .then(s => {
          s.setOpts({
            CompWrapper: {
              Comp: ServiceContextProvider,
              props: { name: 'ApplictionRoot', value: { ioc } },
            },
            ioc,
          });
        })
        .catch(err => {
          console.error('bootstrap fail!', err);
          throw err;
        });
    }
  })
  .catch(err => {
    console.error('load fail!', err);
    throw err;
  });
